// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { useEffect, useState } from 'react';

/**
 * The signed-in user's "track shot detail" preference, set on the profile screen.
 *
 * Off until the user record has been read back, so a slow or failed lookup leaves the hole
 * screen exactly as it is today rather than flashing extra inputs into the score popup.
 */
export function useEnhancedInput(
  apiBaseUrl: string,
  userId: string | null | undefined,
  token: string | null | undefined
): boolean {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!userId || !token) {
      setEnabled(false);
      return;
    }

    let cancelled = false;
    const load = async () => {
      try {
        const response = await fetch(`${apiBaseUrl}/api/users/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) {
          if (!cancelled) setEnabled(false);
          return;
        }
        const payload = (await response.json()) as { enhancedInput?: boolean };
        if (!cancelled) setEnabled(payload.enhancedInput === true);
      } catch {
        if (!cancelled) setEnabled(false);
      }
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [apiBaseUrl, token, userId]);

  return enabled;
}
